<template>
  <div class="sky-switch">
    <itemSearch v-bind="tableData">
      <div class="sky-switch-body">
        <el-switch v-model="val"
                   v-bind="tableData"
                   @change="change"
                   :disabled="disabled">
        </el-switch>
        <div v-if="this.tableData.showBottomText">{{showBottomText()}}</div>
      </div>
    </itemSearch>
  </div>
</template>
<script>
import itemSearch from "@/components/iglobalwin/formComponents/SkySuffix.vue";
export default {
  name: "listSwitch",
  props: {
    tableData: Object,
    scope: Object
  },
  inheritAttrs: false,
  data () {
    return {
      val: this.scope.row[this.tableData.bind]
    };
  },
  computed: {
    disabled () {
      let { scope, tableData } = this;
      if (typeof tableData.disabled == "boolean") {
        return tableData.disabled;
      }
      if (tableData.disabled && typeof tableData.disabled == "function") {
        return tableData.disabled(scope, tableData);
      }
      return true;
    }
  },
  methods: {
    change (val) {
      let { scope, tableData, reset } = this;
      tableData.change && tableData.change(val, scope, tableData, reset);
    },
    reset (oldVal) {
      this.val = oldVal
    },
    showBottomText () {
      let { scope, tableData } = this;
      if (typeof tableData.showBottomText == "function") {
        return tableData.showBottomText(scope, tableData);
      }
      return tableData.showBottomText
    }
  },
  watch: {
    "scope.row": {
      handler () {
        this.val = this.scope.row[this.tableData.bind];
      },
      deep: true
    }
  },
  components: { itemSearch }
};
</script>
<style scoped lang="scss">
.sky-switch {
	display: flex;
	align-items: center;

  .toolFormItem {
    height: 70px;
  }

  .sky-switch-body {
    height: 100%;

    .el-switch {
      margin: 27px 0 5px 0;
    }
  }
}
</style>
